<template>
  <div class="home">
    <div class="home-main">
      <div class="home-main-left">
        <v-chart :options="mapData" @click="toOverview" />
      </div>
      <div class="home-main-right">
        <div style="height: 90px;">
          <common-panel>
            <div class="text-info">
              <div class="text-item">
                <div class="text-label">项目总数(个)</div>
                <div class="text-value">{{attendance.projectCount}}</div>
              </div>
              <div class="text-item">
                <div class="text-label">应打卡(人)</div>
                <div class="text-value">{{attendance.needClockUserCount}}</div>
              </div>
              <div class="text-item">
                <div class="text-label">已打卡(人)</div>
                <div class="text-value">{{attendance.clockedUserCount}}</div>
              </div>
            </div>
          </common-panel>
        </div>
        <div style="height: 20px; min-height: 20px;"></div>
        <common-panel style="flex: 1;">
            <v-chart :options="progressBarData" :autoresize="true" />
        </common-panel>
      </div>
    </div>
    <div style="height: 20px; min-height: 20px;"></div>
    <div class="home-bottom">
      <div style="flex: 1;">
        <common-panel>
          <v-chart :options="attendanceBarData" />
        </common-panel>
      </div>
      <div style="min-width: 20px;"></div>
      <div style="flex: 1;">
        <common-panel>
          <v-chart :options="contractBarData" />
        </common-panel>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ECharts from 'vue-echarts';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/graphic';
import 'echarts/lib/component/geo';
import 'echarts/map/js/china';
import 'echarts/lib/chart/bar';

import CommonPanel from '@/components/CommonPanel.vue';
import PopoverPannel from '@/components/PopoverPannel.vue';
import { PROJECT_ATTENDANCE, PROJECT_CONTRACT, PROJECT_PROGRESS } from '@/api/bigdata';

let popId = '';
let comp = null;

export default {
  components: {
    CommonPanel,
    'v-chart': ECharts,
  },
  data() {
    return {
      attendance: {},
      contract: {},
      progress: {},
      dumpList: [],
      popoverVisable: false,
      styleObject: {
        transform: 'none',
        left: '0px',
        top: '0px',
      },
    };
  },
  mounted() {
    const PopComp = Vue.extend(Object.assign(PopoverPannel, { router: this.$router }));
    popId = PopComp.extendOptions.name;
    comp = new PopComp();
    document.addEventListener('click', this.hiddenPopover, true);
  },
  destroyed() {
    comp.$destroy();
    document.removeEventListener('click', this.hiddenPopover, true);
  },
  computed: {
    attendanceBarData() {
      return {
        title: {
          x: 'center',
          text: '人员情况',
          textStyle: {
            color: '#D8D8D8',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
          formatter: (params) => {
            let text = '0%';
            if (params[0].value !== 0) {
              text = `${Number(params[1].value * 100 / params[0].value).toFixed(0)}%`;
            }
            return `${params[0].name}<br/>
            ${params[0].seriesName}: ${params[0].value}<br/>
            ${params[1].seriesName}: ${params[1].value}<br/>
            出勤率: ${text}`;
          },
        },
        dataZoom: [
          {
            type: 'slider',
            show: (this.attendance.attendanceList || []).length > 9,
            xAxisIndex: [0],
            start: 0,
            end: Number(9 * 100 / (this.attendance.attendanceList || []).length).toFixed(0),
            height: 5,
            bottom: 3,
            zoomLock: true,
            showDetail: false,
            backgroundColor: '#424150',
            borderColor: '#424150',
            fillerColor: '#41CCFF',
          },
        ],
        grid: {
          left: 40,
          right: 20,
        },
        graphic: [
          {
            type: 'group',
            right: 10,
            top: 10,
            z: 100,
            children: [
              {
                type: 'circle',
                left: 0,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#0DD9D2',
                },
              },
              {
                type: 'text',
                left: 15,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '已打卡',
                },
              },
              {
                type: 'circle',
                left: 80,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#0DD9D2',
                },
              },
              {
                type: 'circle',
                left: 82,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 3,
                },
                style: {
                  fill: '#040016',
                },
              },
              {
                type: 'text',
                left: 95,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '应打卡',
                },
              },
            ],
          },
        ],
        xAxis: {
          type: 'category',
          zlevel: 3,
          axisTick: {
            show: false,
          },
          axisPointer: {
            type: 'none',
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
          axisLabel: {
            interval: 0,
            formatter: (value) => {
              const strArr = value.split('').slice(0, 10);
              if (strArr.length > 5) {
                strArr.splice(5, 0, '\n');
              }
              const str = strArr.join('');
              return `{richCss|${str}}`;
            },
            rich: {
              richCss: {
                align: 'center',
              },
            },
          },
          data: (this.attendance.attendanceList || []).map(item => item.name),
        },
        yAxis: {
          type: 'value',
          name: '(人)',
          minInterval: 1,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
        },
        series: [
          {
            name: '应打卡',
            type: 'bar',
            silent: true,
            barWidth: 20,
            barCategoryGap: 40,
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#D8D8D8',
              },
            },
            itemStyle: {
              color: '#040016',
              barBorderColor: '#0DD9D2',
              barBorderWidth: 3,
              barBorderRadius: 0,
            },
            data: (this.attendance.attendanceList || []).map(item => item.needClockUserCount),
          },
          {
            name: '已打卡',
            type: 'bar',
            silent: true,
            barGap: '-100%',
            barWidth: 20,
            barCategoryGap: 40,
            label: {
              show: true,
              position: 'inside',
              textStyle: {
                color: '#D8D8D8',
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#0DD9D2' },
                { offset: 1, color: '#08B6FF' }]),
            },
            data: (this.attendance.attendanceList || []).map(item => item.clockedUserCount),
          },
        ],
      };
    },
    contractBarData() {
      return {
        title: {
          x: 'center',
          text: '劳动合同签订率',
          textStyle: {
            color: '#D8D8D8',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
          formatter: (params) => {
            let text = '0%';
            if (params[0].value !== 0) {
              text = `${Number(params[1].value * 100 / params[0].value).toFixed(0)}%`;
            }
            return `${params[0].name}<br/>
            ${params[0].seriesName}: ${params[0].value}<br/>
            ${params[1].seriesName}: ${params[1].value}<br/>
            签订率: ${text}`;
          },
        },
        dataZoom: [
          {
            type: 'slider',
            show: (this.contract.laborContractList || []).length > 9,
            xAxisIndex: [0],
            start: 0,
            end: Number(9 * 100 / (this.contract.laborContractList || []).length).toFixed(0),
            height: 5,
            bottom: 3,
            zoomLock: true,
            showDetail: false,
            backgroundColor: '#424150',
            borderColor: '#424150',
            fillerColor: '#41CCFF',
          },
        ],
        grid: {
          left: 40,
          right: 20,
        },
        graphic: [
          {
            type: 'group',
            right: 10,
            top: 10,
            z: 100,
            children: [
              {
                type: 'circle',
                left: 0,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#F83A21',
                },
              },
              {
                type: 'text',
                left: 15,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '已签',
                },
              },
              {
                type: 'circle',
                left: 80,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#F83A21',
                },
              },
              {
                type: 'circle',
                left: 82,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 3,
                },
                style: {
                  fill: '#040016',
                },
              },
              {
                type: 'text',
                left: 95,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '应签',
                },
              },
            ],
          },
        ],
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
          axisLabel: {
            interval: 0,
            formatter: (value) => {
              const strArr = value.split('').slice(0, 10);
              if (strArr.length > 5) {
                strArr.splice(5, 0, '\n');
              }
              const str = strArr.join('');
              return `{richCss|${str}}`;
            },
            rich: {
              richCss: {
                align: 'center',
              },
            },
          },
          data: (this.contract.laborContractList || []).map(item => item.name),
        },
        yAxis: {
          type: 'value',
          name: '(人次)',
          minInterval: 1,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: '#D8D8D8',
            },
          },
        },
        series: [
          {
            name: '应签',
            type: 'bar',
            silent: true,
            barWidth: 20,
            barCategoryGap: 40,
            label: {
              show: true,
              position: 'top',
              textStyle: {
                color: '#D8D8D8',
              },
              formatter: (params) => {
                const text = (this.contract.laborContractList || [])[params.dataIndex]
                  .signedUserCount;
                if (params.value === 0) {
                  return `${params.value}(0%)`;
                }
                return `${params.value}(${Number(text * 100 / params.value).toFixed(0)}%)`;
              },
            },
            itemStyle: {
              color: '#040016',
              barBorderColor: '#F83A21',
              barBorderWidth: 3,
              barBorderRadius: 0,
              // opacity: 0.1,
            },
            data: (this.contract.laborContractList || []).map(item => item.needSignUserCount),
          },
          {
            name: '已签',
            type: 'bar',
            barGap: '-100%',
            barWidth: 20,
            barCategoryGap: 40,
            label: {
              show: true,
              position: 'inside',
              textStyle: {
                color: '#D8D8D8',
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#F83A21' },
                { offset: 1, color: '#FE7723' }]),
            },
            data: (this.contract.laborContractList || []).map(item => item.signedUserCount),
          },
        ],
      };
    },
    progressBarData() {
      return {
        title: {
          x: 'center',
          text: '工程进度',
          textStyle: {
            color: '#D8D8D8',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none',
          },
          formatter: (params) => {
            const text = this.formatProgressText(params[1].value / params[0].value);
            const item = (this.progress.projectSchedules || [])[params[0].dataIndex];
            const start = this.$moment(item.planStartupTime).format('YYYY年M月D日');
            const end = this.$moment(item.planCompletedTime).format('YYYY年M月D日');
            return `${params[0].name}<br/>
            ${start} － ${end}<br/>
            最新验收: ${item.applyName || ''}<br/>
            进度状态: ${text}`;
          },
        },
        dataZoom: [
          {
            type: 'slider',
            show: (this.progress.projectSchedules || []).length > 4,
            yAxisIndex: [0],
            right: 10,
            start: 100
              - Number(4 * 100 / (this.progress.projectSchedules || []).length).toFixed(0),
            end: 100,
            width: 5,
            zoomLock: true,
            showDetail: false,
            backgroundColor: '#424150',
            borderColor: '#424150',
            fillerColor: '#41CCFF',
          },
        ],
        grid: {
          left: 80,
        },
        graphic: [
          {
            type: 'text',
            right: '10',
            top: '10',
            z: 100,
            style: {
              fill: '#D8D8D8',
              text: `截止今天（${this.$moment(this.progress.now).format('M月D日')}）`,
            },
          },
          {
            type: 'group',
            left: 'center',
            bottom: 0,
            z: 100,
            children: [
              {
                type: 'circle',
                left: 0,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#08B6FF',
                },
              },
              {
                type: 'text',
                left: 15,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '工期正常',
                },
              },
              {
                type: 'circle',
                top: 'center',
                left: 90,
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#FE7723',
                },
              },
              {
                type: 'text',
                top: 'center',
                left: 105,
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '工期紧张',
                },
              },
              {
                type: 'circle',
                left: 180,
                top: 'center',
                cursor: 'default',
                shape: {
                  cx: 0,
                  r: 5,
                },
                style: {
                  fill: '#E91D04',
                },
              },
              {
                type: 'text',
                left: 195,
                top: 'center',
                cursor: 'default',
                style: {
                  fill: '#D8D8D8',
                  text: '工期已超',
                },
              },
            ],
          },
        ],
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          show: true,
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            formatter: (value) => {
              const strArr = value.split('').slice(0, 10);
              if (strArr.length > 5) {
                strArr.splice(5, 0, '\n');
              }
              const str = strArr.join('');
              return `{richCss|${str}}`;
            },
            rich: {
              richCss: {
                align: 'center',
              },
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#D8D8D8',
            },
          },
          data: (this.progress.projectSchedules || []).map(item => item.name),
        },
        series: [
          {
            type: 'bar',
            silent: true,
            animation: false,
            barGap: '-100%',
            barCategoryGap: 40,
            barWidth: 20,
            itemStyle: {
              color: '#363545',
              barBorderRadius: 10,
            },
            data: (this.progress.projectSchedules || []).map(() => 100),
          },
          {
            type: 'bar',
            silent: true,
            barWidth: 20,
            barCategoryGap: 40,
            label: {
              show: true,
              position: 'insideBottom',
              textStyle: {
                color: '#D8D8D8',
              },
              formatter: params => ((this.progress.projectSchedules || [])[params.dataIndex]
                .applyName) || '',
            },
            itemStyle: {
              barBorderRadius: 10,
              color: (params) => {
                const normal = [{
                  offset: 0, color: '#0DD9D2',
                }, {
                  offset: 1, color: '#08B6FF',
                }];
                const expiring = [{
                  offset: 0, color: '#FEBE1A',
                }, {
                  offset: 1, color: '#FE7723',
                }];
                const delay = [{
                  offset: 0, color: '#FE7723',
                }, {
                  offset: 1, color: '#E91D04',
                }];
                let colors = normal;
                if (params.value >= 85 && params.value < 100) {
                  colors = expiring;
                }
                if (params.value === 100) {
                  colors = delay;
                }
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, colors);
              },
            },
            data: (this.progress.projectSchedules || [])
              .map((item) => {
                const start = this.$moment(item.planStartupTime);
                const end = this.$moment(item.planCompletedTime);
                const now = this.$moment(this.contract.now);
                const total = end.diff(start, 'days');
                const use = now.diff(start, 'days');
                if (use >= total) {
                  return 100;
                }
                if (use < 0) {
                  return 0;
                }
                if (total <= 0) {
                  return 100;
                }
                return (Number(use * 100 / total).toFixed(0));
              }),
          },
        ],
      };
    },
    mapData() {
      return {
        backgroundColor: '#000000',
        animation: true,
        animationDuration: 1000,
        animationEasing: 'cubicInOut',
        animationDurationUpdate: 1000,
        animationEasingUpdate: 'cubicInOut',
        geo: {
          map: 'china',
          layoutCenter: ['50%', '50%'],
          layoutSize: '150%',
          aspectScale: 0.9,
          scaleLimit: {
            min: 0.4,
            max: 1000,
          },
          label: {
            emphasis: {
              show: false,
            },
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: '#2C3966',
              borderColor: '#0DD9D2',
              shadowColor: '#0DD9D2',
              shadowBlur: 3,
            },
            emphasis: {
              areaColor: '#262041',
            },
          },
        },
        series: [
          {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'none',
              },
            },
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: (this.progress.projectSchedules || [])
              .map(item => ({
                name: item.name,
                value: [item.longitude || 116.40, item.latitude || 39.91, item.id, 15],
              })),
            encode: {
              value: 4,
            },
            symbolSize: val => val[3],
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke',
            },
            hoverAnimation: true,
            label: {
              padding: 5,
              color: '#D8D8D8',
              backgroundColor: '#7384BE',
              borderWidth: 1,
              borderRadius: 3,
              formatter: '{b}',
              position: 'top',
              show: true,
            },
            emphasis: {
              label: {
                backgroundColor: '#7793F5',
              },
            },
            itemStyle: {
              color: '#F8AD3A',
              shadowBlur: 10,
              shadowColor: '#333333',
            },
            zlevel: 100,
          },
        ],
      };
    },
  },
  watch: {
    '$store.getters.getCompany': {
      handler: 'getData',
      deep: true,
      immediate: true,
    },
  },
  methods: {
    formatProgressText(schedule) {
      const percent = Number(Number(schedule * 100).toFixed(0));
      if (percent < 85) {
        return '工期正常';
      }
      if (percent >= 100) {
        return '工期已超';
      }
      return '工期紧张';
    },
    hiddenPopover(e) {
      if (e.target.id !== 'popoverPannel') {
        this.popoverVisable = false;
        comp.$set(comp.$props, 'popoverVisable', this.popoverVisable);
      }
    },
    toOverview(params) {
      params.event.stop();
      if (params.componentType !== 'series') {
        this.popoverVisable = false;
        return;
      }
      // this.$set(this.styleObject, 'transform',
      //   `translate(${params.event.event.clientX - 170}px,
      //   ${params.event.event.clientY + 20}px)`);
      this.$set(this.styleObject, 'left', `${params.event.event.clientX - 170}px`);
      this.$set(this.styleObject, 'top', `${params.event.event.clientY + 20}px`);
      const paramsLongitude = Number(Number(params.value[0] || 116.40).toFixed(2));
      const paramsLatitude = Number(Number(params.value[1] || 39.91).toFixed(2));
      this.dumpList = (this.progress.projectSchedules || []).filter((item) => {
        const longitude = Number(Number(item.longitude || 116.40).toFixed(2));
        const latitude = Number(Number(item.latitude || 39.91).toFixed(2));
        if (paramsLongitude === longitude && paramsLatitude === latitude) {
          return true;
        }
        return false;
      });
      if (this.dumpList.length === 1) {
        this.forwardOverview(params.value[2]);
      } else {
        this.popoverVisable = true;
        comp.$set(comp.$props, 'popoverVisable', this.popoverVisable);
        comp.$set(comp.$props, 'dumpList', this.dumpList);
        comp.$set(comp.$props, 'styleObject', this.styleObject);
        if (document.getElementById(popId)) {
          comp.$mount(`#${popId}`);
        } else {
          comp.$mount();
          document.getElementById('app').appendChild(comp.$el);
        }
      }
    },
    forwardOverview(projectId) {
      this.$router.push({ path: `/bigdata/overview/${projectId}` });
    },
    getData(company) {
      if (((company || {}).companyId || '') === '') {
        return;
      }
      const params = { id: company.companyId, type: company.companyType };
      this.$axios.jsonGet(PROJECT_ATTENDANCE, params).then((result) => {
        if (result.code === 0) {
          this.attendance = result.data || {};
        }
      });
      this.$axios.jsonGet(PROJECT_CONTRACT, params).then((result) => {
        if (result.code === 0) {
          this.contract = result.data || {};
        }
      });
      this.$axios.jsonGet(PROJECT_PROGRESS, params).then((result) => {
        if (result.code === 0) {
          this.progress = result.data || {};
          if (this.progress.projectSchedules) {
            this.progress.projectSchedules.reverse();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/theme/app.scss';

  @mixin home-flex {
    display: flex;
  }

  .home {
    @include home-flex;
    flex-direction: column;
    width: 100%;
    &-main {
      @include home-flex;
      flex: 1;
      height: 65%;
      &-left {
        flex: 1;
      }
      &-right {
        width: 35%;
        height: 100%;
        @include home-flex;
        flex-direction: column;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }
    &-bottom {
      @include home-flex;
      justify-content: space-between;
      height: 35%;
    }
  }
  .text-info {
    display: flex;
    justify-content: space-around;
    // align-items: center;
    width: 100%;
    > .text-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      > .text-label {
        color: $font-color;
        font-size: 20px;
      }
      > .text-value {
        color: #F6FF00;
        font-size: 36px;
      }
    }
  }
</style>
